import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
  Box,
  styled,
  SvgIcon,
  Typography,
  useTheme,
  Chip,
} from "@material-ui/core";
import EnsoExperienceIcon from "assets/icons/EnsoExperiences-icon.png";
import {ReactComponent as AirportTransferIcon} from "assets/icons/airport-transfer-icon.svg";
import PrimaryButton from "core/buttons/PrimaryButton";
import CustomSwitch from "core/switches/CustomSwitch";
import EnsoExperiencesDialog from "../dialog/EnsoExperiencesDialog";
import {updateViatorService} from "redux/actions/servicesActions";
import {useTranslation} from "react-i18next";
import AirportTransferDialog from "../dialog/AirportTransferDialog";
import {useFlags} from "launchdarkly-react-client-sdk";

const IconImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "contain",
  borderRadius: "5px",
});

const Card = styled(Box)(({theme}) => ({
  borderRadius: "10px",
  border: "1px solid #F5F5F5",
  backgroundColor: "#F5F5F5",
  display: "flex",
  flexDirection: "row",
  padding: theme.spacing(3),
  gap: theme.spacing(3),
  alignItems: "center",
}));

const IconContainer = styled(Box)(({theme}) => ({
  borderRadius: "5px",
  backgroundColor: theme.palette.primary.white,
  width: 60,
  height: 60,
  padding: 0,
}));

const TextContainer = styled(Box)(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
}));

const UpsellProviderCard = ({}) => {
  const theme = useTheme();
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const serviceAccounts = useSelector(
    (state) => state.defaultReducer.service_accounts,
  );
  const loading = useSelector((state) => state.defaultReducer.loading);
  const viatorEnabled =
    !!serviceAccounts?.accounts?.viator?.[0]?.properties?.enabled;
  const viatorAirportTransferEnabled =
    !!serviceAccounts?.accounts?.viator?.[0]?.properties
      ?.enabled_airport_transfer;
  const [openModal, setOpenModal] = useState(false);
  const [openAirportModal, setOpenAirportModal] = useState(false);
  const [enabled, setEnabled] = useState(viatorEnabled);
  const [airportTransferEnabled, setAirportTransferEnabled] = useState(
    viatorAirportTransferEnabled,
  );
  const flags = useFlags();

  useEffect(() => {
    setEnabled(!!serviceAccounts?.accounts?.viator?.[0]?.properties?.enabled);
    setAirportTransferEnabled(
      !!serviceAccounts?.accounts?.viator?.[0]?.properties
        ?.enabled_airport_transfer,
    );
  }, [serviceAccounts]);

  const toggleSwitch = () => {
    const currValue = enabled;
    setEnabled(!currValue);
    dispatch(
      updateViatorService({
        enable: !currValue,
        // Disable airport transfer if viator is disabled
        enable_airport_transfer:
          !currValue === false ? false : airportTransferEnabled,
        create: !serviceAccounts?.accounts?.viator,
        onError: () => setEnabled((prev) => currValue),
      }),
    );
  };

  const toggleAirportTransferSwitch = () => {
    const currValue = airportTransferEnabled;
    setAirportTransferEnabled(!currValue);
    dispatch(
      updateViatorService({
        enable_airport_transfer: !currValue,
        onError: () => setAirportTransferEnabled((prev) => currValue),
      }),
    );
  };

  return (
    <>
      <EnsoExperiencesDialog
        open={openModal}
        onClose={() => setOpenModal(false)}
      />
      <Card style={{backgroundColor: "white"}}>
        <IconContainer>
          <IconImage src={EnsoExperienceIcon} alt="Enso Experience Icon" />
        </IconContainer>
        <TextContainer>
          <Typography variant="h1">
            {t("enso-experiences-item-title")}
          </Typography>
          <Typography>
            {t("enso-experiences-item-text")}
            <PrimaryButton
              variant="text"
              color="secondary"
              label="Learn More"
              style={{
                padding: "0px 4px",
              }}
              onClick={() => setOpenModal(true)}
            />
          </Typography>
        </TextContainer>
        <Box alignSelf={"center"}>
          <CustomSwitch
            checked={enabled}
            disabled={loading.viator_service || loading.service_accounts}
            customActiveColor={theme.palette.secondary.main}
            onClick={toggleSwitch}
          />
        </Box>
      </Card>
      <AirportTransferDialog
        open={openAirportModal}
        onClose={() => setOpenAirportModal(false)}
      />
      {!!flags.enableAirportTransfer && (
        <Card style={{backgroundColor: "white"}}>
          <IconContainer></IconContainer>
          <TextContainer>
            <div style={{display: "flex"}}>
              <Typography variant="h1" style={{marginRight: 5}}>
                {t("airport-transfer-item-title")}
                {/*<SvgIcon
                  component={AirportTransferIcon}
                  viewBox="0 0 42 41"
                  style={{
                    margin: "0px 8px",
                    color: theme.palette.grey[500],
                  }}
                />*/}
              </Typography>
              <Chip
                color="primary"
                label={"BETA"}
                size="small"
                onClick={() => window.Intercom("showArticle", 10721628)}
              />
            </div>
            <Typography>
              {t("airport-transfer-item-text")}
              <PrimaryButton
                variant="text"
                color="secondary"
                label="Learn More"
                style={{
                  padding: "0px 4px",
                }}
                onClick={() => setOpenAirportModal(true)}
              />
            </Typography>
          </TextContainer>
          <Box alignSelf={"center"}>
            <CustomSwitch
              checked={airportTransferEnabled}
              disabled={
                loading.airport_transfer_service ||
                loading.service_accounts ||
                !!!viatorEnabled
              }
              customActiveColor={theme.palette.secondary.main}
              onClick={toggleAirportTransferSwitch}
            />
          </Box>
        </Card>
      )}
    </>
  );
};

export default UpsellProviderCard;
